import { Card, Form, Segmented } from "antd";
import React, { useEffect, useState } from "react";
import SeoForms from "../../components/SeoConfig/SeoForms";
import { SEOServices } from "../../Services/SEOServices";
import { notify } from "../../customs/NotifyProvider";
import ContactPC from "../PageContent/ContactPC";

const ContactusPageSeo = () => {
  const [form] = Form.useForm();
  const [seoData, setSeoData] = useState(null); 
   const [activeSegment, setActiveSegment] = useState("content");

  const onFinish = async (values) => {
    try {
      const formattedVal = { ...values, page_id: 3 };

      let response;

      if (seoData?.id) {
        response = await SEOServices.updateSEODetails(
          seoData.id,
          formattedVal
        );
      }
      else {
        response = await SEOServices.addSEODetails(formattedVal);
      }

      if (response?.status) {
        notify.success(response.message);
        getPageSeo(); 
      } else {
        notify.error(response.message);
      }
    } catch (error) {
      console.error(error);
      notify.error("Something went wrong");
    }
  };

  const getPageSeo = async () => {
    try {
      const response = await SEOServices.getSEODetialById(3);

      console.log(response.data);
      

      if (response?.data?.length > 0) {
        const record = response.data[0];
        setSeoData(record);        // store existing record
        form.setFieldsValue(record); // populate form
      } else {
        setSeoData(null);
        form.resetFields();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getPageSeo();
  }, []);

  return (

    <Card title="Contact us Page Configuration">

      <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
        <Segmented
          size="large"
          block
          value={activeSegment}
          onChange={setActiveSegment}
          options={[
            { label: "Page Content", value: "content" },
            { label: "SEO", value: "seo" },
          ]}
          style={{
            width: "70%",
            padding: 6,
            borderRadius: 8,
          }}
        />
      </div>


      {/* SEGMENT CONTENT */}
      {activeSegment === "content" && (
        <ContactPC />
      )}

      {activeSegment === "seo" && (
        <SeoForms form={form} onFinish={onFinish} />
      )}
    </Card>
    // <Card title="Contact us Page SEO">
      
    // </Card>
  );
};

export default ContactusPageSeo;
